'use es6';

import { na1 } from 'hubspot-url-utils/hublets';
import WebRespondent from '../records/WebRespondentRecord';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { hubletApi } from 'hub-http/middlewares/core';
import * as Env from './environment';
const bundleObj = {
  bundleVersion: Env.bundleVersion
};
const LIVE_TEST_URL = `feedback/public/v1/survey-test`;
const submitRatingUrl = surveyType => `feedback/public/v1/submit/${surveyType.toLowerCase()}`;
const submitFollowUpUrl = surveyType => `feedback/public/v1/submission-follow-up/${surveyType.toLowerCase()}`;
const submitEmailUrl = 'feedback/public/v1/identity-association/email';

// submissions for HubSpot surveys should always be rerouted to na1
const getHubletApi = ({
  isHubspot = false
}) => isHubspot ? hubletApi('feedback', 'hubapi', na1) : hubletApi('feedback', 'hubapi');
export const fetchLiveTestSurveyConfig = (testKey, parentUrl) => noAuthApiClient.get(`${LIVE_TEST_URL}/${testKey}`, {
  api: hubletApi('feedback', 'hubapi'),
  headers: {
    'X-HS-Referer': parentUrl
  },
  withCredentials: false
}).then(config => {
  return {
    config,
    webRespondent: WebRespondent({
      hasEmail: !config.gdprSettings
    })
  };
});
export const submitRating = (surveyType, data) => noAuthApiClient.post(submitRatingUrl(surveyType), {
  api: getHubletApi(data),
  query: bundleObj,
  headers: {
    'X-HS-Referer': data.webAnalytics.pageUrl
  },
  data,
  withCredentials: false
});
export const submitFollowUp = (surveyType, parentUrl, data) => noAuthApiClient.post(submitFollowUpUrl(surveyType), {
  api: getHubletApi(data),
  query: bundleObj,
  data: Object.assign({}, data, bundleObj, {
    surveyType
  }),
  headers: {
    'X-HS-Referer': parentUrl
  },
  withCredentials: false
});
export const submitEmail = (parentUrl, data) => noAuthApiClient.post(submitEmailUrl, {
  api: getHubletApi(data),
  query: bundleObj,
  data,
  headers: {
    'X-HS-Referer': parentUrl
  },
  withCredentials: false
});